import { WebSocketStream } from './websocket-stream';

declare var MozWebSocket; // eslint-disable-line no-var

export function WebSocketStreamFactory () {
  function _createWebSocket (url) {
    if ('WebSocket' in window) {
      return new WebSocket(url);
    } else if ('MozWebSocket' in window) {
      return new MozWebSocket(url);
    }

    return null;
  }

  return WebSocketStream(_createWebSocket);
}
